import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '../../components/container';
import styles from './not-found.module.scss';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.notFound}>
      <Container>
        <div className={styles.status}>
          <span>404</span>
        </div>
        <p>Page not found.</p>
        <p>This page doesn't exist or was removed.</p>

        <button onClick={() => navigate('/')}>Home</button>
      </Container>
    </div>
  );
};

export default NotFound;
